import {noop} from "lodash";
import {
    Aging_Search,
    Calculate_Detail,
    Calculate_Estimate,
    Cancel_Invoicing,
    Create_Product,
    Dict_Type,
    Fee_No,
    Fee_No_Filter,
    OCP_Generate_Invoice,
    OwnerCash_Pay_Invoicing,
    Quickbook_Generate_Invoice,
    Quickbook_Invoicing,
    Requisition_Add,
    Requisition_Add_Check,
    Requisition_Delete, Requisition_OCP_Generate, Requisition_OCP_Generate_,
    Requisition_Update,
    Requisition_Warehouse_list,
    Send_Invoice_Email,
    Stripe_Pay_Invoicing
} from "../../config";
import api from "../../api/api";
import {ReportsActionType} from "../reports/reportsAction";
import {InventoryActionType} from "../inventory/inventoryAction";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import {onSuccessAlert} from "../message/messageActions";

export const BillingActionType = {
    Fetch_Terms:"Fetch_Terms",
    Fetch_Fee_No:'Fetch_Fee_No',
    Fetch_Filtered_Fee_No:'Fetch_Filtered_Fee_No',
    Fetch_Warehouse_Tax_Rate:'Fetch_Warehouse_Tax_Rate',
    Calculate_Estimate:'Calculate_Estimate',
    Calculate_Detail:'Calculate_Detail'
}

export const get_all_terms = (onSuccess = noop, onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_terms_type_list'}} )
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:BillingActionType.Fetch_Terms,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }
}


export const add_receipt = (data, onSuccess = noop,onError = noop) => async dispatch => {

    if (!checkPermission(PERMISSION_DICT.BillingCollectionAdd)) return null;

    try {
        const url = `${Requisition_Add}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.code === 200){

            onSuccess("BillingPage.CollectionRequisition.Created a Receipt Successfully")
        } else {

            onError(response?.data?.msg || "BillingPage.CollectionRequisition.Receipt creation failed.")
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const check_permission_requisition = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.BillingCollectionCheck)) return null;
        const url = `${Requisition_Add_Check}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.code === 200){

            onSuccess(true)
        } else if(response?.status === 200 && response?.data?.code === 500){
            onSuccess(false)
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const edit_receipt = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.BillingCollectionModify)) return null;
        const url = `${Requisition_Update}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.code === 200){

            onSuccess("BillingPage.CollectionRequisition.Update a Receipt Successfully")
        } else {

            onError(response?.data?.msg || "BillingPage.CollectionRequisition.Failed to edit receipt.")
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const delete_receipt = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.BillingCollectionDelete)) return null;
        const url = `${Requisition_Delete}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.code === 200){

            onSuccess("BillingPage.CollectionRequisition.Delete a Receipt Successfully")
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const receipt_warehouse_list = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingCollectionWarehouse)) return null;
        const url = `${Requisition_Warehouse_list}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.code === 200){
            dispatch({
                type:BillingActionType.Fetch_Warehouse_Tax_Rate,
                payload:response?.data?.data
            })
            onSuccess("GetWarehouse Successfully")
        } else if(response?.data?.code === 500 && response?.data?.msg === 'Owner is not exist') {

            onError(`BillingPage.CollectionRequisition.${response?.data?.msg}`)
        } else {
            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const requisition_ocp_generate = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingCollectionGenerate)) return null;
        const url = `${Requisition_OCP_Generate}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess("Generate OCP Invoice Successfully")
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const ocp_generate_invoice = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceOCPGenerate)) return null;
        const url = `${OCP_Generate_Invoice}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess("Generate Invoice Successfully")
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const quickbook_generate_invoice = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceQBGenerate)) return null;
        const url = `${Quickbook_Invoicing}`
        const response = await api.get(url,{params:{invoiceNo:data?.invoiceNo + ""}})
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess("BillingPage.InvoicePage.Generate QuickBooks Invoice Successfully")
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const cancel_invoice = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceCancel)) return null;
        const url = `${Cancel_Invoicing}`
        const response = await api.post(url,data)
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess("BillingPage.InvoicePage.Cancel Invoice Successfully")
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const owner_Cash_Pay_Invoicing = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceBalancePay)) return null;
        const url = `${OwnerCash_Pay_Invoicing}`
        const response = await api.post(url,data)
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess(response?.data)
        } else {
            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const strip_Pay_Invoicing = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceCreditCardPay)) return null;
        const url = `${Stripe_Pay_Invoicing}`
        const response = await api.post(url,data)
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess("BillingPage.InvoicePage.Deduction Successful")
        } else {
            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const send_invoice_email = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceEmailSend)) return null;
        const url = `${Send_Invoice_Email}`
        const response = await api.post(url,data)
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess(response?.data.msg)
        } else {
            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}


export const get_fee_no_list = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        const url = `${Fee_No}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.code === 200){

            dispatch({
                type:BillingActionType.Fetch_Fee_No,
                payload:response?.data?.rows
            })
            onSuccess(response?.data?.rows)
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const get_filtered_fee_no_list = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        const url = `${Fee_No_Filter}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.code === 200){

            dispatch({
                type:BillingActionType.Fetch_Filtered_Fee_No,
                payload:response?.data?.rows
            })
            onSuccess(response?.data?.rows)
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}


export const get_calculate_estimate = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingCalculateEstimate)) return null;
        const url = `${Calculate_Estimate}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.data?.code === 200){

            dispatch({
                type:BillingActionType.Calculate_Estimate,
                payload:response?.data?.data?.data
            })

            onSuccess(response?.data?.data?.data)
        } else {

            onError(response?.data?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const get_calculate_detail = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingCalculateCalculate)) return null;
        const url = `${Calculate_Detail}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.data?.code === 200){

            dispatch({
                type:BillingActionType.Calculate_Detail,
                payload:response?.data?.data?.data
            })

            onSuccess(response?.data?.data)
        } else {

            onError(response?.data?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const getQBTest = (onSuccess = noop,onError = noop,getAuthenticated = noop) => async dispatch => {
    const url = `${Quickbook_Generate_Invoice}`
    try {
        const response = await api.get(url, { maxRedirects: 0 }); // 禁用自动重定向
        const responseData = response?.data

        const width = 400;
        const height = 600;
        const left = (screen.width / 2)-200;
        const top = (screen.height / 2)-400;


        const parser = new DOMParser();
        const doc = parser.parseFromString(responseData, 'text/html');
        const script = doc.querySelector('script');
        const targetUrl = script.textContent.match(/window\.location\.href\s*=\s*['"]([^'"]+)['"]/)[1];
        const newWindow = window.open('', '_blank',`width=${width},height=${height},left=${left},top=${top}`);
        newWindow.document.open();
        newWindow.document.write(responseData);
        newWindow.document.close();

        window.addEventListener("message", function(event) {
            // 检查消息来源是否为子窗口的URL
            // if (event.origin === "子窗口的URL") {
            if (event.data === "close") {
                // console.log("收到关闭消息");
                // 关闭子窗口或执行其他操作
                dispatch(onSuccessAlert('Connect QuickBooks Successfully.'))
                getAuthenticated()
                // loginWindow.close();
            }
            // }
        });



    } catch (error) {
        console.error("请求失败：", error);
    }
}

